"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragHandle = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./DragHandle.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("../WidgetManager");
var slate_1 = require("slate");
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var Router_1 = __importDefault(require("../Router"));
var EditorTypes_1 = require("../EditorTypes");
var lodash_1 = require("lodash");
var classnames_1 = __importDefault(require("classnames"));
var slate_react_1 = require("slate-react");
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var DragHandle = function (_a) {
    var show = _a.show, className = _a.className, element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var _b = (0, SyntheticSelection_1.useSelectionStore)(), setSelection = _b.setSelection, clearSelection = _b.clearSelection;
    var account = (0, inversify_react_1.useInjection)("account");
    var user = (0, inversify_react_1.useInjection)("user");
    var editor = (0, inversify_react_1.useInjection)(EditorTypes_1.SlateEditor.$);
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var router = (0, inversify_react_1.useInjection)(Router_1.default);
    var conversionElem = (0, inversify_react_1.useInjection)("conversionElem");
    var _c = __read((0, react_1.useState)(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), ignoreNextClick = _d[0], setIgnoreNextClick = _d[1];
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 800 }, function (_a) {
        var zIndex = _a.zIndex;
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { isOpen: isOpen, onClose: function () { return setIsOpen(false); }, position: "left", alignment: "start", className: styles.widgetMenu, style: { zIndex: zIndex }, button: react_1.default.createElement("button", { "data-drag-handle": true, onClick: function (event) {
                    telemetry.identify(user, account, { drag_handle_used: true });
                    telemetry.trackOnly(Telemetry_1.TelemetryEventName.DragHandleUsed, {
                        method: "clicked",
                        inline_content_type: element.type,
                    });
                    if (ignoreNextClick)
                        return;
                    if (event.shiftKey || event.ctrlKey || event.metaKey)
                        return;
                    setIsOpen(!isOpen);
                }, onMouseDown: function () {
                    if (isOpen) {
                        setIsOpen(false);
                    }
                    setIgnoreNextClick(isOpen);
                }, className: (0, classnames_1.default)(className, styles.dragHandle({
                    show: show || isOpen,
                })) },
                react_1.default.createElement(icons_1.DragHandle, { size: icons_1.IconSize.Medium, color: "default" })) },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "duplicate",
                        path: widgetManager.getPath(element),
                        type: element.type,
                    }));
                    telemetry.trackOnly(Telemetry_1.TelemetryEventName.DragHandleUsed, {
                        menu_action: "duplicate",
                    });
                    var newWidgetPath = slate_1.Path.next(widgetManager.getPath(element));
                    (0, lodash_1.defer)(function () {
                        setSelection([{ path: newWidgetPath, editor: editor, router: router, conversionElem: conversionElem }]);
                        var _a = __read(slate_1.Editor.node(editor, newWidgetPath), 1), newWidgetNode = _a[0];
                        var newWidgetDomNode = slate_react_1.ReactEditor.toDOMNode(editor, newWidgetNode);
                        (0, scroll_into_view_if_needed_1.default)(newWidgetDomNode, {
                            behavior: "smooth",
                            scrollMode: "if-needed",
                            block: "center",
                        });
                    });
                } }, "Duplicate"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "delete",
                        path: widgetManager.getPath(element),
                        type: element.type,
                    }));
                    telemetry.trackOnly(Telemetry_1.TelemetryEventName.DragHandleUsed, {
                        menu_action: "delete",
                    });
                    clearSelection();
                } }, "Delete")));
    }));
};
exports.DragHandle = DragHandle;
